import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Mixin extends Vue {
  public stringComparator(a: string, b: string, descending = false): number {
    if (descending) {
      return b.localeCompare(a);
    }

    return a.localeCompare(b);
  }

  public numberComparator(a: number, b: number, descending = false): number {
    if (descending) {
      return b - a;
    }

    return a - b;
  }

  public dateComparator(a: Date, b: Date, descending = false): number {
    if (descending) {
      return b.getTime() - a.getTime();
    }

    return a.getTime() - b.getTime();
  }
}
